export enum DynamicHealthPlanStepType {
	FORM = 'FORM',
	EDUCATION_MATERIALS = 'EDUCATION_MATERIALS',
	QUESTIONNAIRES = 'QUESTIONNAIRES',
	REQUIREMENTS = 'REQUIREMENTS',
}
